module.exports = __webpack_public_path__ + "img/marketing-budget.202df1e7.png";